import { render, staticRenderFns } from "./PlaceSettingModal.vue?vue&type=template&id=5b0b3690"
import script from "./PlaceSettingModal.vue?vue&type=script&lang=js"
export * from "./PlaceSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports